module.exports = __webpack_public_path__ + "media/images/icon_next_white-c49d63957adf4b665f8abdd0762f4e59.svg";